<!--
 * @Autor: yingna.gao
 * @Date: 2022-09-14 14:34:53
 * @LastEditTime: 2022-09-14 15:13:12
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/views/standard/role/components/role-view.vue
-->
<template>
  <el-dialog
    v-dialogDrag
    :title="$t('role.roleView')"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="527px"
    class="self-dialog-form"
  >
    <el-form
      ref="formRef"
      label-position="top"
      :model="formData"
      :disabled="true"
      @submit.native.prevent
    >
      <el-form-item :label="$t('role.roleName')">
        <el-input v-model="formData.roleName" autocomplete="off" :max-length="64" />
      </el-form-item>
      <el-form-item :label="$t('role.roleCode')">
        <el-input v-model="formData.roleCode" autocomplete="off" maxlength="64" />
      </el-form-item>
      <el-form-item :label="$t('role.roleDescription')">
        <el-input
          v-model="formData.description"
          type="textarea"
          maxlength="200"
          :rows="4"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "RoleDetail",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      formData: {}
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  created() {
    this.formData = JSON.parse(JSON.stringify(this.content));
  },
  methods: {}
};
</script>

<style></style>
